/**
 * Groups and sorts submetrics into categories and metrics.
 * @param {InsightMetric[] | SubMetricEvaluation[]} submetrics - The submetrics to group and sort.
 * @returns {Category[]} A sorted array of categories.
 */
export function groupAndSortSubmetrics(submetrics) {
    const categoriesMap = {};
    submetrics.forEach(submetric => {
        const categoryName = submetric.gut_vaginal_health.key_insights_category.key_insights_sections
            .display_title;
        const metricName = submetric.gut_vaginal_health.key_insights_category.category_title;
        const metricKey = submetric.gut_vaginal_health.category_key;
        if (!categoriesMap[categoryName]) {
            const shortDesc = submetric.gut_vaginal_health.key_insights_category.key_insights_sections
                .short_description;
            categoriesMap[categoryName] = {
                name: categoryName,
                priority: submetric.gut_vaginal_health.key_insights_category
                    .key_insights_sections.priority,
                short_description: shortDesc,
                metrics: {},
                orderedMetrics: [],
            };
        }
        const category = categoriesMap[categoryName];
        let metric = category.metrics[metricName];
        if (!metric) {
            metric = {
                id: submetric.gut_vaginal_health.key_insights_category.id,
                name: metricName,
                categoryKey: metricKey, // key_insights_category is a "metric"
                sectionOrder: submetric.gut_vaginal_health.key_insights_category.section_order,
                submetrics: {},
                orderedSubmetrics: [],
            };
            category.metrics[metricName] = metric;
        }
        metric.submetrics[submetric.name] = submetric;
    });
    for (const category of Object.values(categoriesMap)) {
        const sortedMetrics = Object.entries(category.metrics)
            .sort(([, a], [, b]) => (a.sectionOrder ?? 0) - (b.sectionOrder ?? 0))
            .map(([key, metric]) => {
            const sortedSubmetrics = Object.values(metric.submetrics).sort((a, b) => (a.category_order
                ? a.category_order
                : (a.gut_vaginal_health.category_order ?? 0)) -
                (b.category_order
                    ? b.category_order
                    : (b.gut_vaginal_health.category_order ?? 0)));
            metric.orderedSubmetrics = sortedSubmetrics;
            return metric;
        });
        category.orderedMetrics = sortedMetrics;
    }
    const orderedCategories = Object.values(categoriesMap).sort((a, b) => b.priority - a.priority);
    return orderedCategories;
}
//# sourceMappingURL=groupAndSortSubmetrics.js.map